import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { InboxPage } from "../components/inbox/InboxPage";
import { inboxSearchSchema } from "../components/inbox/inbox-search";

/** The Inbox (BUILD_SPEC §12.8): its view and the issue in its peek in the address. */
function Page() {
  const search = useSearch({ from: "/admin/inbox" });
  const navigate = useNavigate({ from: "/admin/inbox" });
  return <InboxPage search={search} onSearch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }) })} />;
}

export const Route = createFileRoute("/admin/inbox")({ validateSearch: inboxSearchSchema, component: Page });
